import { memo, useMemo } from "react";

import { BreadcrumbsView } from "./Breadcrumbs.view";
import { BreadcrumbsPlaceholder } from "./BreadcrumbsPlaceholder.view";

interface Props {
  breadcrumbsLabel: string;
  homeLabel: string;
  isLoading?: boolean;
  items: { title: string; url: string }[];
}

const BreadcrumbsBase = ({
  breadcrumbsLabel,
  homeLabel,
  isLoading = false,
  items,
}: Props) => {
  const updatedItems = useMemo(
    () => [{ title: homeLabel, url: "/" }, ...items],
    [items]
  );
  return isLoading ? (
    <BreadcrumbsPlaceholder />
  ) : (
    <BreadcrumbsView breadcrumbsLabel={breadcrumbsLabel} items={updatedItems} />
  );
};

export const Breadcrumbs = memo(BreadcrumbsBase);
